
import { categoryIcons } from '../categoryIcons'
import { tr } from '../translate'
import Chevron from '@/assets/icons/support_ticket/chevron.svg?inline'

export default {
  components: { Chevron },
  props: {
    config: {
      type: Object,
      default: null,
    },
    selectedKey: {
      type: String,
      default: null,
    },
  },
  data() {
    return { categoryIcons }
  },
  methods: {
    tr(entry) {
      return tr(entry, this.$i18n.locale)
    },
    label(category) {
      return tr(category.translations, this.$i18n.locale)?.label
    },
    description(category) {
      return tr(category.translations, this.$i18n.locale)?.sub
    },
  },
}
